import * as React from 'react';
import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/avatarLink.svg?inline';

export interface AvatarLinkComponentProps {
	readonly image: string;
	readonly linkTitle: string;
	readonly linkUrl?: string;
}

const register = <TProps extends AvatarLinkComponentProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'AvatarLink',
		image,
		inputs: [
			{
				name: 'image',
				type: 'file',
				allowedFileTypes: ['webp', 'jpg', 'png'],
			},
			{
				name: 'linkTitle',
				type: 'string',
				defaultValue: 'Some category',
			},
			{
				name: 'linkUrl',
				type: 'string',
			},
		],
	});
};

export default register;
